import React from 'react';

function Home() {
  return (
    <>
      <h2 className="home-title"> This an example of implemetation of infinite scroll in two ways.</h2>
      <p className="center">Hey! Very happy to see you in my tiny application.</p>
    </>
  );
}

export default Home;
